import * as angular from "angular";
import template from "./entity-overview-tab.html";
import type { ModalTabItem } from "../../../modals/tabbed-modal/tabbed-modal-types";
import { globs } from "../../../../services/globs";
import { isSupportedOrNullish } from "../../isSupportedOrNullish";
import type {
	EntityModel,
	EntityOperation,
	EntityTypeConfig
} from "./entityModalTabTypes";

const entityNameTypeMap: Record<string, Record<string, string>> = {
	VESSEL: {
		text: "default"
	},
	GROUP: {
		text: "default"
	},
	FISHERMAN: {
		text: "allowed",
		contact: "default"
	},
	DEALER: {
		text: "default",
		contact: "allowed"
	},
	BUSINESS: {
		text: "default",
		contact: "allowed"
	},
	LICENSE: {}
};

export interface EntityOverviewTabController {
	entity?: EntityModel;
	typeConfig: EntityTypeConfig;
	initialMode?: string;
	onCreate: EntityOperation;
	save: EntityOperation;
	put: EntityOperation;
	post: EntityOperation;
}

// AngularJS owns these merged binding properties; keeping them type-only preserves pre-assigned values.
// eslint-disable-next-line no-redeclare
export class EntityOverviewTabController {
	public static $inject = ["securityService"];

	public tab!: ModalTabItem;
	public isReadonly = true;
	public nameComponentOptions: Record<string, string> = {};
	public showIdentifiers = false;
	public showClassifications = false;

	public constructor(private readonly securityService) {}

	public $onInit(): void {
		const typeCode = this.typeConfig.Code;
		this.tab = {
			name: `${this.entity === undefined ? "New " : ""}${this.typeConfig.Name}`,
			code: "OVERVIEW"
		};
		this.nameComponentOptions = entityNameTypeMap[typeCode];
		this.isReadonly = !this.securityService.isActionAllowed(globs.entityTypes.byType(typeCode).write);

		const canViewIdentifiers = globs.entityTypes.byType(typeCode).identifiers.byCode("*").read;
		this.showIdentifiers = this.securityService.isActionOrPatternAllowed(canViewIdentifiers)
			&& isSupportedOrNullish(this.typeConfig.Identifiers);

		const canViewClassifications = globs.entityTypes.byType(typeCode).classifications.byCode("*").read;
		this.showClassifications = this.securityService.isActionOrPatternAllowed(canViewClassifications)
			&& isSupportedOrNullish(this.typeConfig.Classifications);
	}
}

export default angular
	.module("vesl.components.entity-modal.tabs.entity-overview-tab", [])
	.component("entityOverviewTab", {
		controller: EntityOverviewTabController,
		template,
		bindings: {
			entity: "<",
			typeConfig: "<",
			initialMode: "<",
			onCreate: "&",
			save: "&",
			put: "=",
			post: "="
		}
	})
	.name;
